/** @format */
import Routes from './Routes'

function App() {
	return (
		<div className='view'>
			<div className='viewbox'>
				<div className='container'>
					<Routes />
				</div>
			</div>
		</div>
	);
}

export default App;
